import React from 'react';
import { CardsSVG } from '../../components';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { palette } from '../../styles/theme';

export default function ClientDropHeader () {
    const { t } = useTranslation();
    return (
        <Box className='dropHeader'>
            <Box className='svgIcon'>
                <CardsSVG customStroke={palette.secondary[600]}/>
            </Box>
            <Typography variant='pageHeaderTitle' className='headerText'>{t('cards.title')}</Typography>
        </Box>
    );
}
